var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.5C12.8284 6.5 13.5 5.82843 13.5 5V2C13.5 1.17157 12.8284 0.5 12 0.5C11.1716 0.5 10.5 1.17157 10.5 2V5C10.5 5.82843 11.1716 6.5 12 6.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.271 6.10586L6.149 3.98486C5.55466 3.42041 4.62234 3.42041 4.028 3.98486C3.44243 4.57061 3.44243 5.52011 4.028 6.10586L6.15 8.22686C6.43098 8.50869 6.81303 8.66641 7.211 8.66486C7.81684 8.66392 8.36265 8.29862 8.5945 7.7389C8.82635 7.17917 8.69873 6.53492 8.271 6.10586Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 12C0.5 12.8284 1.17157 13.5 2 13.5H5C5.82843 13.5 6.5 12.8284 6.5 12C6.5 11.1716 5.82843 10.5 5 10.5H2C1.17157 10.5 0.5 11.1716 0.5 12Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.957 15.524C6.55933 15.5225 6.17761 15.6803 5.897 15.962L3.775 18.084C3.21807 18.6753 3.23289 19.6024 3.80844 20.1755C4.38399 20.7486 5.31115 20.7595 5.9 20.2L8.022 18.078C8.44985 17.6488 8.57741 17.0044 8.34531 16.4445C8.1132 15.8847 7.56703 15.5196 6.961 15.519L6.957 15.524Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 22C10.5 22.8284 11.1716 23.5 12 23.5C12.8284 23.5 13.5 22.8284 13.5 22V19C13.5 18.1716 12.8284 17.5 12 17.5C11.1716 17.5 10.5 18.1716 10.5 19V22Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.049 16.0062C15.4634 16.5919 15.4634 17.5414 16.049 18.1272L18.171 20.2482C18.7573 20.8361 19.7091 20.8374 20.297 20.2512C20.8849 19.6649 20.8863 18.7131 20.3 18.1252L18.173 16.0002C17.8908 15.7189 17.5082 15.5614 17.1098 15.5625C16.7113 15.5636 16.3296 15.7233 16.049 16.0062Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 12C23.5 11.1716 22.8284 10.5 22 10.5H19C18.1716 10.5 17.5 11.1716 17.5 12C17.5 12.8284 18.1716 13.5 19 13.5H22C22.8284 13.5 23.5 12.8284 23.5 12Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.044 3.41017C18.6463 3.40866 18.2646 3.56639 17.984 3.84817L15.864 5.96817C15.5822 6.24954 15.4238 6.63143 15.4238 7.02967C15.4238 7.4279 15.5822 7.80979 15.864 8.09117C16.4497 8.67674 17.3993 8.67674 17.985 8.09117L20.106 5.97117C20.5354 5.54203 20.6638 4.89637 20.4313 4.33559C20.1987 3.7748 19.6511 3.40949 19.044 3.41017Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.c2dde786.svg";
export { ForwardRef as ReactComponent };